import { QueryClient, UseQueryOptions, useQuery } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { minutes, seconds } from "@/3514/utils"
import Urls from "@/api/urls"

import { QueryKey } from "../constants"

const getAvailability = async () => {
    const { data } = await axiosClient.get(Urls.avRulesAttrs())
    return data
}

export function useAvailability(options?: Partial<UseQueryOptions>) {
    return useQuery({
        queryKey: [QueryKey.AvRulesAttrs],
        queryFn: getAvailability,
        retry: 1,
        retryDelay: seconds(5),
        throwOnError: false,
        ...options,
        refetchOnMount: options?.refetchOnMount || "always"
    })
}

export async function coachAvailabilityQueryPrefetcher({ qc }: { qc: QueryClient }): Promise<void> {
    await qc.prefetchQuery({
        queryKey: [QueryKey.AvRulesAttrs],
        queryFn: getAvailability,
        staleTime: minutes(20),
        gcTime: minutes(20),
        retry: false
    })
}
